import React from "react";

import "./style.scss";

interface ToggleSwitchProps {
  label?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  id?: string;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  label,
  checked,
  onChange,
  disabled = false,
  className = "",
  id,
}) => {
  const handleToggle = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <div className={`toggle-switch-container ${className}`}>
      {label && (
        <label className="toggle-switch-label" htmlFor={id}>
          {label}
        </label>
      )}
      <div className="toggle-switch-wrapper">
        <input
          type="checkbox"
          id={id}
          checked={checked}
          onChange={handleToggle}
          disabled={disabled}
          className="toggle-switch-input"
        />
        <label
          htmlFor={id}
          className={`toggle-switch ${checked ? "checked" : ""} ${
            disabled ? "disabled" : ""
          }`}
        >
          <span className="toggle-switch-thumb"></span>
        </label>
      </div>
    </div>
  );
};

export default ToggleSwitch;
